import * as ROUTES from "../constants/routes";
import { Promotion } from "../pages/priceLists/Promotion";
import { useSelectedRouteParams } from "./useSelectedRouteParams";

export function PromotionRoute() {
  const { promotionId } = useSelectedRouteParams(ROUTES.PROMOTION);

  return <Promotion promotionId={promotionId} />;
}

export function PromotionStandaloneRoute() {
  const { promotionId } = useSelectedRouteParams(ROUTES.PROMOTION_STANDALONE);

  return (
    <Promotion
      promotionId={promotionId}
      backRoute={ROUTES.PROMOTIONS_STANDALONE}
    />
  );
}
